<template>
    <eg-modal height="auto" :width="width" :show="show" @close="$emit('close', false)">
        <div class="my-proposal-modal-body" slot="body">
            <p>Faça seu login ou cadastre-se de forma gratuita e participe de nossas cotações.</p>
        </div>
        <div class="my-proposal-footer" slot="footer">
            <div style="display: flex" class="buttons-footer">
                <eg-button
                    variant="eg-blue-outline"
                    id="login-redirect"
                    style="margin-inline: 10px"
                    @click="redirectToSingin"
                    >Entrar</eg-button
                >
                <eg-button style="margin-inline: 10px; text-transform: initial" @click="redirectToSingup"
                    >Cadastre-se</eg-button
                >
            </div>
        </div>
    </eg-modal>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    name: 'guestPanel',
    props: { show: Boolean, width: String, height: String, isMobile: Boolean, competition: Object },
    methods: {
        ...mapActions('router', ['setRedirectUrl']),
        redirectToSingup() {
            this.$router.push({ name: 'Signup' });
        },
        redirectToSingin() {
            if (this.competition && this.competition.nextSlot.id) {
                this.setRedirectUrl(this.$route.fullPath);
            }
            this.$router.push({ name: 'Login' });
        }
    }
};
</script>
